function StringToSVG({inputString, fontSize, textColor, backgroundColor}) {
  const svgDataURI = generateSVG(inputString, fontSize, textColor, backgroundColor);

  return (
    <div>
      <img src={svgDataURI} alt="Generated SVG"/>
    </div>
  );
}

function generateSVG(inputString, fontSize, textColor, backgroundColor) {
  // Create an SVG element
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("width", "200"); // Set the width
  svg.setAttribute("height", "50"); // Set the height

  // Create a rectangle to serve as the background
  const background = document.createElementNS("http://www.w3.org/2000/svg", "rect");
  background.setAttribute("width", "100%");
  background.setAttribute("height", "100%");
  background.setAttribute("fill", backgroundColor); // Background color
  svg.appendChild(background);

  // Create the text element
  const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
  text.setAttribute("x", "50%");
  text.setAttribute("y", "50%");
  text.setAttribute("text-anchor", "middle");
  text.setAttribute("dominant-baseline", "middle");
  text.setAttribute("font-size", fontSize);
  text.setAttribute("fill", textColor);
  text.setAttribute("font-family", "Trebuchet MS");
  text.setAttribute("font-weight", "700");
  text.textContent = inputString; // Set the text content
  svg.appendChild(text);


  const svgString = new XMLSerializer().serializeToString(svg);

  return `data:image/svg+xml,${encodeURIComponent(svgString)}`;
}

export default StringToSVG;
